import { render, staticRenderFns } from "./OneTimePassCompletePane.vue?vue&type=template&id=5ba32fae&scoped=true"
import script from "./OneTimePassCompletePane.vue?vue&type=script&lang=ts"
export * from "./OneTimePassCompletePane.vue?vue&type=script&lang=ts"
import style0 from "./OneTimePassCompletePane.vue?vue&type=style&index=0&id=5ba32fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba32fae",
  null
  
)

export default component.exports